/**
 * RegExp for password is inspired by
 * https://www.thepolyglotdeveloper.com/2015/05/use-regex-to-test-password-strength-in-javascript/
 */

export const ValidationPatterns = {
  passwordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*["\-_,.!@#$%^&*])(?=.{8,})/,
  allowedSpecialCharacters: '"-_,.!@#$%^&*',
};
